import { render, staticRenderFns } from "./trackingno.vue?vue&type=template&id=567e064e&scoped=true"
import script from "./trackingno.vue?vue&type=script&lang=js"
export * from "./trackingno.vue?vue&type=script&lang=js"
import style0 from "./trackingno.vue?vue&type=style&index=0&id=567e064e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e064e",
  null
  
)

export default component.exports